import { render, staticRenderFns } from "./taskListDialog.vue?vue&type=template&id=6b3a7342&scoped=true&"
import script from "./taskListDialog.vue?vue&type=script&lang=js&"
export * from "./taskListDialog.vue?vue&type=script&lang=js&"
import style0 from "./taskListDialog.vue?vue&type=style&index=0&id=6b3a7342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a7342",
  null
  
)

export default component.exports